import instance from './axiosInstance';

function getDashboards(reqBody, options = {}, http = instance) {
  return http.get('/dashboards', reqBody, options);
}

function getPrivatePulse5Dashboards(reqBody, _options = {}, http = instance) {
  return http.get('/dashboards/pulse5/all', reqBody);
}

function getPublicPulse5Dashboards(reqBody, _options = {}, http = instance) {
  return http.get('/dashboards/pulse5/all?public=true', reqBody);
}

function getPulse4Dashboards(reqBody, _options = {}, http = instance) {
  return http.get('/dashboards/pulse4', reqBody);
}

function getDashboardTypes(reqBody = {}, options = {}, http = instance) {
  return http.get('/dashboards/types', reqBody, options);
}

function getDashboardById(dashboardId, options = {}, http = instance) {
  return http.get(`/dashboards/pulse5/${dashboardId}`, {}, options);
}

function fetchDashboard(dashboardId, options = {}, http = instance) {
  return http.get(`/dashboards/${dashboardId}`, {}, options);
}

function createDashboard(reqBody, options = {}, http = instance) {
  return http.post('/dashboards', reqBody, options);
}

function updateDashboard(payload, options = {}, http = instance) {
  return http.put(`/dashboards/${payload.id}`, payload.payload, options);
}

function updateDashboardMeta(payload, options = {}, http = instance) {
  return http.put(`/dashboards/meta/${payload.id}`, payload.payload, options);
}

function removeDashboard(dashboardId, options = {}, http = instance) {
  return http.delete(`/dashboards/${dashboardId}`, {}, options);
}

function cloneDashboard(payload, options = {}, http = instance) {
  return http.post(`/dashboards/clone/${payload.id}`, payload.payload, options);
}

export {
  getDashboards,
  getPrivatePulse5Dashboards,
  getPublicPulse5Dashboards,
  getPulse4Dashboards,
  getDashboardTypes,
  fetchDashboard,
  getDashboardById,
  createDashboard,
  updateDashboard,
  updateDashboardMeta,
  removeDashboard,
  cloneDashboard,
};
